import { Button, ButtonGroup, InlineStack, TextLabel } from '@customerio/pluma-components/react';
import type { DeliverySearchBy } from '../types';

type SearchByToggleProps = {
  searchBy: DeliverySearchBy;
  onToggle: (next: DeliverySearchBy) => void;
};

/**
 * The "find by adding filters / email address" toggle (email channel only).
 * Ported from the Ember `<PlumaButtonGroup>` in `<cio-deliveries>`.
 */
export function SearchByToggle({ searchBy, onToggle }: SearchByToggleProps) {
  return (
    <InlineStack alignBlock="center" gap="100">
      <TextLabel>Find by</TextLabel>
      <ButtonGroup size="sm">
        <Button isActive={searchBy === 'filter'} onClick={() => onToggle('filter')}>
          adding filters
        </Button>
        <Button isActive={searchBy === 'email'} onClick={() => onToggle('email')}>
          email address
        </Button>
      </ButtonGroup>
    </InlineStack>
  );
}
